import React, { useEffect } from 'react'
import toast from 'react-hot-toast';
import { Link, useNavigate } from 'react-router-dom';

const Header = ({ handleOpen }) => {
    const navigate = useNavigate();

    const handleLogout = () => {
        localStorage.removeItem('PAY_ADMIN_TOKEN');
        localStorage.removeItem('PAY_ADMIN_NAME');
        localStorage.removeItem('PAY_ADMIN_IMG');
        localStorage.removeItem('A_FORGET_EMAIL');
        toast.success('Logged Out Successfully')
        navigate('/admin/login');
    }

    useEffect(() => {
        if (localStorage.getItem('PAY_ADMIN_TOKEN') === null) {
            navigate("/admin/login");
        }
    }, [navigate]);


    return (
      <div className="header">
        <div className="header-left">
          <Link to="/admin/dashboard" className="logo">
            {/* <img src="/assets/img/colorLS.svg" width="50px" height="40" alt="Logo" /> */}
            <span className="logo-text fw-bolder ">CodeIgnity</span>
          </Link>
          <Link to="/admin/dashboard" className="logo2">
            {/* <img src="/assets/img/colorLS.svg" width="50px" height="40" alt="Logo" /> */}
            <span className="logo-text fw-bolder ">CodeIgnity</span>
          </Link>
        </div>

        {/* eslint-disable jsx-a11y/anchor-is-valid */}
        <a id="toggle_btn">
          <span className="bar-icon">
            <span></span>
            <span></span>
            <span></span>
          </span>
        </a>

        <div className="page-title-box">
          <h3>{localStorage.getItem("PAY_ADMIN_NAME")}</h3>
        </div>

        <a onClick={handleOpen} className="mobile_btn">
          <i className="fa-solid fa-bars"></i>
        </a>

        <ul className="nav user-menu">
          <li className="nav-item dropdown has-arrow main-drop">
            <a
              href="#"
              className="dropdown-toggle nav-link"
              data-bs-toggle="dropdown"
            >
              <span className="userImg">
                <img
                  src={localStorage.getItem("PAY_ADMIN_IMG")}
                  alt="User-pic"
                  style={{
                    borderRadius: "50%",
                    height: "30px",
                    width: "30px",
                    objectFit: "cover",
                  }}
                />
                <span className="status online"></span>
              </span>
              <span>{localStorage.getItem("PAY_ADMIN_NAME")}</span>
            </a>
            <div className="dropdown-menu">
              <Link className="dropdown-item" to="/admin/edit-profile">
                My Profile
              </Link>
              {/* <a className="dropdown-item" href="settings.html">Settings</a> */}
              <a className="dropdown-item" onClick={handleLogout}>
                Logout
              </a>
            </div>
          </li>
        </ul>

        <div className="dropdown mobile-user-menu">
          <a
            href="#"
            className="nav-link dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="fa-solid fa-ellipsis-vertical"></i>
          </a>
          <div className="dropdown-menu dropdown-menu-right">
            <Link className="dropdown-item" to="/admin/edit-profile">
              My Profile
            </Link>
            {/* <a className="dropdown-item" href="settings.html">Settings</a> */}
            <a className="dropdown-item" onClick={handleLogout}>
              Logout
            </a>
          </div>
        </div>
      </div>
    );
}

export default Header